<template>
  <div>
    <div class="md-card md-card-tabs">
      <h4 class="md-card-header font_bold">{{title}}</h4>
      <div class="md-card-content">
        <div class="flex flex_between chart_head" v-show="displayChart">
          <div class="head_left">
            <span></span>
            {{$t('dashboard.Receivables.soldVolume')}}
          </div>
        </div>
        <div v-show="displayChart" class="chart" ref="myEchartPillar" style="height:400px"></div>
        <emptyChart v-show="!displayChart"></emptyChart>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EmptyChart from "@/views/dashboard/EmptyChart";
export default {
  props: {
    showTitle: { type: Boolean, default: true }
  },
  components: {
    EmptyChart
  },
  data() {
    return {
      option: {},
      title: this.$t("dashboard.ExpectedColumnar.title1"),
      displayChart: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setData();
    });
  },
  beforeMount() {},
  methods: {
    setOption() {
      this.option = {
        title: {
          text: ""
        },
        color: ["#0071EB", "#FEC07D"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#0071EB"
            },
            label: {
              backgroundColor: "#0071EB"
            }
          }
        },
        toolbox: {
          feature: {
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ["line", "bar"] },
            // restore: { show: true },
            // saveAsImage: { show: true }
          }
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12"
            ],
            axisPointer: {
              type: "shadow"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: "receivables volume",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: a => {
                return this.formatMoney(a);
              }
            }
          }
        ],
        series: [
          {
            name: this.$t("dashboard.Receivables.soldVolume"),
            type: "bar",
            barWidth: "60%",
            data: []
          }
        ]
      };
    },
    setMonth(data) {
      this.setData(data);
    },
    setData(year) {
      if (!year) {
        year = new Date();
        year = moment(year).format("YYYY");
      }

      this.setOption();
      let option = this.option;
      let myChart = echarts.init(this.$refs.myEchartPillar);
      let xAxisData = option.xAxis[0].data;
      xAxisData = xAxisData.map(item => {
        item = year + "-" + item;
        return item;
      });

      let yAxisLeft = option.yAxis[0];
      yAxisLeft.interval = Math.floor(yAxisLeft.max / 5);

      option.xAxis[0].data = xAxisData;
      let series = option.series;
      // totalSoldVolume
      let { statisticData } = this.dashboardInfo;
      let volumeData = [];
      let volumeDataSort = [];
      if (
        statisticData &&
        statisticData.monthlyCostOfCapital &&
        statisticData.monthlyCostOfCapital.length > 0
      ) {
        this.displayChart = true;
        statisticData.monthlyCostOfCapital.forEach(item => {
          volumeData.push(item.totalSoldVolume);
          volumeDataSort = [...volumeData];
        });
        volumeDataSort = volumeDataSort.sort(function(a, b) {
          return a - b;
        });
      } else {
        this.displayChart = false;
      }
      yAxisLeft.min = 0;
      yAxisLeft.max = volumeDataSort[volumeDataSort.length - 1];
      yAxisLeft.interval = Math.floor((yAxisLeft.max - yAxisLeft.min) / 5);

      series[0].data = volumeData;
      myChart.setOption(option);
      setTimeout(function() {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 500);
    },
    floorInterval(value, times) {
      if (value > 0 && value < 1) {
        return this.floorInterval(value * 10, times +1);
      } else {
        return (Math.floor(value) + 1) / Math.pow(10, times);
      }
    }
  },
  computed: {
    ...mapGetters({
      dashboardInfo: "dashboardInfo",
      dashboardFilter: "dashboardFilter"
    })
  },
  watch: {
    dashboardInfo() {
      let { years } = this.dashboardFilter;
      this.setMonth(years);
    }
  }
};
</script>